export enum processGeneratesDocumentsName {
    PROCESS = "process",
    DOCUMENT_OF_PROCESS = "documentosDoProcesso",
    DISPATCH_DOCUMENTO = "documentosDeDespacho",
    ADDITIONAL_DOCUMENTS = "documentosComplementares",
    CERTIFICATE = "certidao"
}

export enum requestGeneratesDocumentsName {
    REQUEST = "request",
    DOCUMENT_OF_REQUEST = "documentosDeSolicitacao",
}